import React from "react";
import ReactDOM from "react-dom";
// import { CookiesProvider } from "react-cookie";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <React.StrictMode>
    {/* <CookiesProvider> */}
    <App />
    {/* </CookiesProvider> */}
  </React.StrictMode>,
  document.getElementById("root")
);

// if (
//   process.env.REACT_APP_ENV === "production" ||
//   process.env.REACT_APP_ENV === "staging"
// ) {
//   document.oncontextmenu = (event) => {
//     event.preventDefault();
//   };
//   document.addEventListener("contextmenu", (event) => {
//     event.preventDefault();
//   });
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
